/**
 * Created by mqamhieh on 11/17/16.
 */
window.SignUpForm = function ($scope, hUser, brand, jobId, localize, httpHelper, referrer, source) {

    var form = this;
    var formName = "signup-form";
    var _protected = BaseForm.call(form, formName, $scope);
    form.isKickstart = referrer === 'Kickstart';
    form.source = source;
    form.showOptInMessagesCb = false;
    if (form.isKickstart) {
        form.data.is_public = true;
    }
    var brandId = brand && brand.id;

    form.isOAuthEnabled = publicConfiguration.isOAuthEnabled();

    var submittingUnLoading = function(){
        setTimeout(function (){
            delete form.submitting;
            $scope.$digest();
        }, 200);
    };

    form.doSignUp = async () => {
        try {
            delete form.errorMessage;

            if (form.submitting) {
                throw new Error("Form is already submitting.");
            }
            form.submitting = true;

            const isValid = await new Promise((resolve) => {
                form.validator.validate(resolve);
            });

            if (!isValid) {
                setTimeout(() => {
                    $(".error:visible:first").parent().find('input')[0].focus();
                    submittingUnLoading();
                }, 100);
                form.submitting = false;
                return;
            }

            const signUp = async (gRecaptchaResponse) => {
                let newUser = {
                    'first_name': form.data.first_name,
                    'last_name': form.data.last_name,
                    'email': form.data.email,
                    'password': form.data.password,
                    'phone': window.intlTelInputUtils.formatNumber(form.data.phone, undefined, window.intlTelInputUtils.numberFormat.E164),
                    'registration_source': form.data.registration_source,
                    'registration_mode': 'NORMAL'
                };

                if (gRecaptchaResponse) {
                    newUser['g-recaptcha-response'] = gRecaptchaResponse;
                }

                if (form.isQuickApplyEnabled) {
                    newUser['password'] = createUUID();
                    newUser['registration_mode'] = 'NO_PASSWORD';
                }

                let referrer_username = hUser.getUserNameReferral();

                const signUpRes = await hLoginManager.signUp(newUser.email, newUser.password, newUser.phone, { google_recaptcha: newUser['g-recaptcha-response'] });
                if (!signUpRes.success) {
                    form.errorMessage = Utils.humanizeoAuthErrorResponse(signUpRes.error ? signUpRes.error : '');
                    submittingUnLoading();
                    throw new Error("Sign up failed.");
                }

                const loginResp = await hLoginManager.login(newUser.email, newUser.password);
                if (!loginResp.success) {
                    hAlert("Error" + "!", $filter("translate")("Something went wrong, please try again later."));
                    submittingUnLoading();
                    throw new Error("Login failed.");
                }

                const placeholderToken = HStorageManager.get({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: 'placeholder_token'
                });
                let payload = {
                    first_name: newUser.first_name,
                    last_name: newUser.last_name,
                    user_type: 'CANDIDATE',
                    mode: newUser.registration_mode
                };
                if (placeholderToken) {
                    payload.placeholder_token = placeholderToken;
                }
                if (brand) {
                    payload.brand = {
                        id: brand.id,
                        name: brand.name
                    };
                }

                await UserAPI.registerOAuthNewUser(payload);
                await hUser.getFullUserData();
                hUser.login();
                if (form.isKickstart) {
                    httpHelper.p('user/privacy', {
                        is_public: !!form.data.is_public
                    });
                }

                _protected.trigger("on-form-saved");

                if (localize.getLang() !== 'en') {
                    await SettingsAPI.saveUserLocale(localize.getLang());
                }
                submittingUnLoading();
                HStorageManager.remove({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: 'placeholder_token'
                });
                return "Sign up and login successful.";
            };

            const token = await hRecaptchaUtil.execute(`register`);
            return await signUp(token);
        } catch (err) {
            submittingUnLoading();
            hAlert("Error" + "!", $filter("translate")("Something went wrong, please try again later."));
            throw err;
        }
    };

    form.reSendEmail = function () {
        var data = {
            email: form.data.email
        };
        form.reSendingEmail = true;
        LightSignUpAPI.resendVerificationEmail(data)
            .then(function (res) {
                HNotifications.show({
                    title: $filter("translate")("Success"),
                    desc: $filter("translate")("An email has been sent to you successfully") + ".",
                    icon: "fa-check-circle",
                    type: "success"
                });
            })
            .catch(function (err) {
                console.error(err);
                HNotifications.show({
                    title: $filter("translate")("Something Went Wrong"),
                    desc: $filter("translate")("Failed to send you email") + "!",
                    icon: "fa-ban",
                    type: "danger"
                });
            })
            .finally(function () {
                delete form.reSendingEmail;
                form.syncScope();
            });
    };

    form.socialLoginStarted = function () {
        form.socialLogin = true;

        $scope.$on('logged-in-from-oauth', function (event, provider, userData) {
            delete form.socialLogin;
        });

        $scope.$on('error-from-oauth', function (event, provider, error) {
            delete form.socialLogin;
        });
    };

    form.setFirstName = function (firstName) {
        form.data.first_name = firstName || "";
    };

    form.setLastName = function (lastName) {
        form.data.last_name = lastName || "";
    };

    form.showGDPRDisclaimer = function (isGDPREnabled) {
        form.showDisclaimer = isGDPREnabled;
    };

    form.showOptInMessagesCheckbox = function (showOptInMessages) {
        form.showOptInMessagesCb = showOptInMessages;
    };

    form.setJobType = function (jobType) {
        form.jobType = jobType;
    };

    form.setSource = function (source) {
        form.data.registration_source = source;
    };

    form.goToLogin = function () {
        console.warn("Override this function");
    };

    form.setQuickApplyStatus = function (isQuickApplyEnabled) {
        form.isQuickApplyEnabled = isQuickApplyEnabled;
    };

    form.validator.onAsyncValidationDone(function (ruleName, validIfExisting, validationData) {

        form.validationData = validationData;

        $scope.$digest();
    });

    form.validator.validateCustom = function (field, optionsField, rule, showError) {

        var name = field.attr("name");
        var value = form.validator.getFieldValue(field);

        switch (rule.name) {
            case "password-email-match":
                if(value && (value === form.data.email)){
                    if (showError) {
                        form.validator.validation[name].errors[rule.name] = true;
                    }
                    return false;
                }
                break;

            case "weak-password":
                if(value && !Utils.validatePassword(value).pass && Utils.validatePassword(value).strength === 'weak') {
                    if (showError) {
                        form.validator.validation[name].errors[rule.name] = true;
                    }
                    return false;
                }
                break;

            case "short-password":
                if(value && !Utils.validatePassword(value).pass && Utils.validatePassword(value).strength === 'short') {
                    if (showError) {
                        form.validator.validation[name].errors[rule.name] = true;
                    }
                    return false;
                }
                break;

            case "invalid-password":
                if(value && !Utils.validatePassword(value).pass && Utils.validatePassword(value).strength === 'invalid') {
                    if (showError) {
                        form.validator.validation[name].errors[rule.name] = true;
                    }
                    return false;
                }
                break;
        }
        return true;
    };

    const init = () => {
        self.loadingRecaptcha = true;

        hRecaptchaUtil.initRecaptchaScript()
            .finally(() => {
                self.loadingRecaptcha = false;
                $scope.$digest();
            });
    };

    init();

    form.doValidation = async () => {
        const isValid = await new Promise(resolve => form.validator.validate(resolve));
        return isValid;
    };

};
